export default __webpack_public_path__ + "static/TTNormsProBold-41b36245aa2f67373970d744fc6241ce.woff2";